export function getImage(src: string): string {
    return typeof window === "undefined"
        ? src
        : window.location.origin + src;
}